import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class SerologicalJarModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('serological_jar').clone();
        this.model.position.set(0, .12, -.2);
        this.addObject(this.model);
        this.tripod = ResourcesManager.getModel('serological_jar_tripod').clone();
        this.tripod.position.set(.14, 0, 0);
        this.addObject(this.tripod);
        this.level = level;
    }
    init() { }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.model, callback = () => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.model, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            // PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToJar = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(-0.3, -16.5, -16));
                if (distanceToJar < 1.8) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.model, callback);
            });
        }
    }
    setEmptyTube() {
        // this.disposeObject(this.testTube);
        this.emptyTestTube = ResourcesManager.getModel('test_tube_empty').clone();
        this.emptyTestTube.position.set(0, .16, 0);
        this.addObject(this.emptyTestTube);
    }
}
